import _ from "lodash";

export const IDENTITY_DESIGNATIONS_CONSTANTS = [
  {
    title: "Teacher",
    locale: "schoolSetup:desig_1_title",
  },
  {
    title: "PYP Coordinator",
    locale: "schoolSetup:desig_2_title",
  },
  {
    title: "IT Specialist",
    locale: "schoolSetup:desig_3_title",
  },
  {
    title: "School Administrator",
    locale: "schoolSetup:desig_4_title",
  },
  {
    title: "Other",
    locale: "schoolSetup:desig_5_title",
  },
  {
    title: "Student",
    locale: "common:student",
  },
  {
    title: "Family member",
    locale: "common:family_member",
  },
  {
    title: "Visitor",
    getLocale: ({ t }) => {
      return `${t("snp:visitor")} - ${t("snp:authorization_evaluation")}`;
    },
  },
];

export const getLocalizedDesignation = ({ title, t }) => {
  const { locale, getLocale } =
    _.find(
      IDENTITY_DESIGNATIONS_CONSTANTS,
      ({ title: identityTitle }) => title === identityTitle
    ) ?? {};

  return getLocale ? getLocale({ t }) : t(locale, { defaultValue: title });
};

export const getDesignation = ({ designation, userType, t }) => {
  switch (userType) {
    case "student": {
      return { title: getLocalizedDesignation({ title: "Student", t }) };
    }
    case "parent": {
      return { title: getLocalizedDesignation({ title: "Family member", t }) };
    }
    case "staff": {
      return {
        title: getLocalizedDesignation({ title: designation.title, t }),
        id: designation.id,
      };
    }
    default: {
      return { title: userType };
    }
  }
};

/**
 * This util will take userList data structure(which contains identity details) and converts it in
 * a format which can be used in OrganizationList Component
 */
export const getLinkedIdentities = ({ userList, t }) => {
  return _.map(userList, user => {
    const {
      org_id,
      org_name,
      org_logo,
      user_id,
      user_type,
      identity_id,
      designation,
      isAccessBlockedDueToMfa,
      isMfaEnabled,
      mfaEnabledMethods,
    } = user;

    const organization = {
      id: org_id,
      name: org_name,
      logo: org_logo,
    };

    return {
      id: user_id,
      organization,
      designation: getDesignation({ userType: user_type, designation, t }),
      userType: user_type,
      identityId: identity_id,
      isAccessBlockedDueToMfa,
      isMfaEnabled,
      mfaEnabledMethods,
    };
  });
};

export const getUserLinkedIdentitiesDetailsFromIdentityPool = ({
  identityPoolDetails,
  t,
}) => {
  const { edges } = identityPoolDetails;

  const userList = _.map(edges, ({ node }) => node);

  const linkedIdentities = getLinkedIdentities({ userList, t });

  return { linkedIdentities };
};
